import {Divider, FormControl, InputLabel, MenuItem, Select, TextField, Grid, Typography} from '@material-ui/core';
import States from 'ApplicationEntry/models/States';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import * as EM from 'ApplicationEntry/components/WorkFlow/ErrorMessages';
import {
  changeAddress,
  changeAddressLine2,
  changeCity,
  changeName,
  changeState,
  changeZip,
} from 'ApplicationEntry/ducks/secondaryAddressee';
import {SecondaryAddressee} from 'ApplicationEntry/models/SecondaryAddressee';
import {
  isEmptyZipCode,
  isValidZipCode,
  ZipCode,
  unmaskZipCode,
  maskZipCode,
  ValidZipCode,
} from 'ApplicationEntry/models/ZipCode';
import './SecondaryAddressee.sass';

type SecondaryAddresseeProps = {
  secondaryAddressee: SecondaryAddressee;
};

const SecondaryAddresseeSection = (props: SecondaryAddresseeProps) => {
  const {secondaryAddressee} = props;
  const dispatch = useDispatch();

  const [stateLabel, setStateLabel] = useState<HTMLLabelElement | null>();
  const [ZipBlurred, setBlurZip] = useState(false);
  const showZipError = ZipBlurred && !isEmptyZipCode(secondaryAddressee.zip) && !isValidZipCode(secondaryAddressee.zip);

  const getZipErrorMessage = (zip: ZipCode) => (!isValidZipCode(zip) ? EM.INVALID_ZIP_FORMAT : null);
  return (
    <form noValidate autoComplete="off" className="secondary-addressee-section">
      <div className="secondary-addressee-section__title-container">
        <Typography variant="subtitle1" className="secondary-addressee-section__title-container-title">
          Second Addressee
        </Typography>
      </div>

      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <TextField
            id="secondary-addressee-name"
            label="Name"
            variant="outlined"
            placeholder="Enter Name"
            margin="normal"
            fullWidth
            className="secondary-addressee-section__field"
            value={secondaryAddressee.name.value}
            onChange={e => dispatch(changeName(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="secondary-addressee-address"
            label="Address"
            variant="outlined"
            placeholder="Enter Address"
            margin="normal"
            className="secondary-addressee-section__field"
            value={secondaryAddressee.address.value}
            onChange={e => dispatch(changeAddress(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="secondary-addressee-addressLine2"
            label="Address Line 2"
            variant="outlined"
            placeholder="Apartment, Suite, Building, Floor, etc..."
            margin="normal"
            className="secondary-addressee-section__field"
            value={secondaryAddressee.addressLine2.value}
            onChange={e => dispatch(changeAddressLine2(e.target.value))}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="secondary-addressee-city"
            label="City"
            variant="outlined"
            placeholder="Enter City"
            margin="normal"
            className="secondary-addressee-section__field"
            value={secondaryAddressee.city.value}
            onChange={e => dispatch(changeCity(e.target.value))}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <FormControl variant="outlined" className="secondary-addressee-section__field">
            <InputLabel ref={el => setStateLabel(el)} id="select-state-label">
              State
            </InputLabel>
            <Select
              labelWidth={stateLabel?.clientWidth}
              labelId="select-state-label"
              id="select-state"
              value={secondaryAddressee.state.value}
              onChange={e => dispatch(changeState(e.target.value as string))}
            >
              <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              {States.map((stateCode, index) => (
                <MenuItem value={stateCode} key={stateCode}>
                  {stateCode}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            className="secondary-addressee-section__field"
            error={showZipError}
            helperText={showZipError ? getZipErrorMessage(secondaryAddressee.zip) : ''}
            id="secondary-addressee-zip"
            inputProps={{maxLength: 10}}
            label="Zip"
            onBlur={() => setBlurZip(true)}
            onChange={e => dispatch(changeZip(ValidZipCode.create(unmaskZipCode(e.target.value))))}
            placeholder="XXXXX-XXXX"
            value={maskZipCode(secondaryAddressee.zip.value)}
            variant="outlined"
          />
        </Grid>
      </Grid>

      <Divider className="application-form__actions-divider" />
    </form>
  );
};

export default SecondaryAddresseeSection;
